var TableComponent_1;
import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./table.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./table.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, Input, Output, Renderer2, ViewChildren } from "@angular/core";
import SearchUtils from "../../utils/search-utils";
import { compare } from "../../models/sort.model";
import { TableSortHeaderDirective } from "../../directives/table-sort-header.directive";
import _ from "underscore";
import { SharedConstants } from "../../constants/shared.constants";
import moment from "moment";
import { ActivatedRoute, Router } from "@angular/router";
import { ApplicationTableColumnMappingService } from "../../services/table-column-mapping/application-table-column-mapping.service";
import { PropertyTableColumnMappingService } from "../../services/table-column-mapping/property-table-column-mapping.service";
import { AlertType } from "../../models/alert";
import { AppControllerService } from "../../../app-controller.service";
import { SearchTableService } from "../../services/table-column-mapping/search-table.service";
import { SearchContainerHeight } from "../../services/afla-module-strategy/afla-module-strategy.service";
import { ModuleConfigService } from "../../services/module-config/module-config.service";
import { ApplicationMapSearchService } from "../../../tabs/applications/application-search/shared/application-map-search.service";
import { GuidUtils } from "../../utils/guid-utils";
import { POITableColumnMappingService } from "../../services/table-column-mapping/poi-table-column-mapping.service";
import { StreetTableColumnMappingService } from "../../services/table-column-mapping/street-table-column-mapping.service";
import { BayTableColumnMappingService } from "../../services/table-column-mapping/bay-table-column-mapping.service";
import { utils, writeFile } from "xlsx";
import { AutoUnsub } from "../../decorators/autounsub.decorator";
import { AppConfig } from "src/app/app.config";
import { APP_BASE_HREF } from "@angular/common";
let elId = 0;
let TableComponent = class TableComponent {
    static { TableComponent_1 = this; }
    baseHref;
    changeDetectorRef;
    route;
    router;
    appTableColumnMappingService;
    propertyTableColumnMappingService;
    bayTableColumnMappingService;
    POIsTableColumnMappingService;
    streetTableColumnMappingService;
    applicationMapSearchService;
    appControllerService;
    renderer;
    searchTableService;
    moduleConfigService;
    headers;
    tableItems;
    columnToItemPropertyMap;
    tdTemplate;
    thTemplate;
    rowActions = false;
    checkboxColumn = false;
    showRadioButtonColumn = false;
    allowSingleSelect = false;
    disableFilter = false;
    disableRowSelect = true;
    nextID = elId++;
    pageName;
    defaultSort;
    showRecipientTypeColumn = false;
    parentComponent = "";
    allowExport = false;
    isApplicationSearchTable = false;
    isDataPreSorted = false;
    tableItemClicked = new EventEmitter();
    tableItemsChecked = new EventEmitter();
    recipientRadioButtonClicked = new EventEmitter();
    branding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR,
        themeActiveAlternateColor: SharedConstants.DEFAULT_ACTIVE_ALTERNATE_COLOR,
        themePrimaryButtonColor: SharedConstants.DEFAULT_PRIMARY_BUTTON_COLOR
    };
    guid = GuidUtils.MakeNew().ToString();
    tableColumns;
    visibleTableItems;
    searchTerm;
    selectedColumn;
    focusedElement;
    selectedRows = [];
    isSelected = false;
    filterByOptions;
    noItemsMessage = SharedConstants.NO_ITEMS_AVAILABLE_MESSAGE;
    noFilterResults = SharedConstants.NO_FILTER_RESULTS;
    preSelectedFilterText;
    preSelectedFilterColumn;
    isTableItemsRefreshed = true;
    isTableColumnMappingRefreshed = true;
    exportTextLabel = SharedConstants.EXPORT_LABEL;
    exportFilenamePlaceholderText;
    exportFilenameLabel = SharedConstants.ENTER_FILENAME_LABEL;
    defaultSearchItems = SharedConstants.DEFAULT_SEARCH_ITEMS_RETURNED;
    defaultSearchItemsOptions = SharedConstants.DEFAULT_SEARCH_ITEMS_OPTIONS;
    fetchRecordCountValue = 50;
    exportFilenameText;
    isCemeteryModuleSearch = false;
    isCemeteryLocationSearch = false;
    isCemeteryLocationSearchWithMap = false;
    isPropertiesSearchWithMap = false;
    isCemeterySimpleSearch = false;
    isCemeteryApplicationMap = false;
    requireClientContainerCheck = true;
    applyTableWidthClass = false;
    mapSearchObservable;
    searchCriteriaHeight = 0;
    mapHeight = 0;
    setTableGridSizeSubscription;
    queryParamsSubscription;
    appTableItemsObservableSubscription;
    appTableColumnMapObservableSubscription;
    propertyTableItemsObservableSubscription;
    propertyTableColumnMapObservableSubscription;
    graveTableItemsObservableSubscription;
    graveTableColumnMapObservableSubscription;
    bayTableItemsObservableSubscription;
    bayTableColumnMapObservableSubscription;
    poiTableItemsObservableSubscription;
    poiTableColumnMapObservableSubscription;
    streetTableItemsObservableSubscription;
    streetTableColumnMapObservableSubscription;
    jobIdFieldName = "jobid";
    applicationLinkFieldName = "Application link";
    constructor(baseHref, changeDetectorRef, route, router, appTableColumnMappingService, propertyTableColumnMappingService, bayTableColumnMappingService, POIsTableColumnMappingService, streetTableColumnMappingService, applicationMapSearchService, appControllerService, renderer, searchTableService, moduleConfigService) {
        this.baseHref = baseHref;
        this.changeDetectorRef = changeDetectorRef;
        this.route = route;
        this.router = router;
        this.appTableColumnMappingService = appTableColumnMappingService;
        this.propertyTableColumnMappingService = propertyTableColumnMappingService;
        this.bayTableColumnMappingService = bayTableColumnMappingService;
        this.POIsTableColumnMappingService = POIsTableColumnMappingService;
        this.streetTableColumnMappingService = streetTableColumnMappingService;
        this.applicationMapSearchService = applicationMapSearchService;
        this.appControllerService = appControllerService;
        this.renderer = renderer;
        this.searchTableService = searchTableService;
        this.moduleConfigService = moduleConfigService;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.branding = AppConfig.settings.projectSettings.styling;
        }
        this.fetchRecordCountValue = appControllerService.fetchRecordCountValue;
    }
    static checkIfObject(test) {
        return typeof test === "object";
    }
    static checkIfDate(test) {
        return moment(test, SharedConstants.SYSTEM_DATE_FORMAT_DEFAULT, true).isValid();
    }
    checkIfNumber(maybeNumber) {
        const checkNumber = Number(maybeNumber);
        return !isNaN(checkNumber);
    }
    getObjectId(row) {
        // @ts-ignore
        return row.hasOwnProperty("id") ? row.id.toString() : "";
    }
    ngAfterViewInit() {
        this.headers.forEach((header) => {
            if (header.sortable === this.defaultSort) {
                header.direction = "asc";
            }
        });
        this.exportFilenamePlaceholderText = this.getToday();
        this.expandTableHorizontally();
    }
    getToday() {
        const month = (new Date().getMonth() + 1).toString();
        const day = new Date().getDate().toString();
        const hours = new Date().getHours().toString();
        const minutes = new Date().getMinutes().toString();
        const today = `${new Date().getFullYear()}`
            + `${month.length < 2 ? "0" + month : month}`
            + `${day.length < 2 ? "0" + day : day}`
            + `${hours.length < 2 ? "0" + hours : hours}`
            + `${minutes.length < 2 ? "0" + minutes : minutes}`;
        return `${SharedConstants.EXPORT_FILENAME_PLACEHOLDER_TEXT}_${today}`;
    }
    ngOnChanges(changes) {
        this.isSelected = false;
        this.selectedRows = [];
        // this.tableItemsChecked.emit(this.selectedRows);
        this.tableItems = changes.tableItems ? changes.tableItems.currentValue : this.tableItems;
        if (this.showRecipientTypeColumn) {
            this.setDefaultRecipientType();
        }
        this.setInitialVisibleTableItems();
        if (this.tableItems) {
            this.filterTable({ text: this.searchTerm, column: this.selectedColumn });
        }
        this.exportFilenamePlaceholderText = this.getToday();
        if (changes.hasOwnProperty("columnToItemPropertyMap") && !this.applyTableWidthClass)
            this.expandTableHorizontally();
    }
    ngOnInit() {
        this.checkIfColumnMappingExists();
        this.initialize();
        this.listenForQueryParamChanges();
        this.listenForAppSearchChanges();
        this.listenForPropertySearchChanges();
        this.listenForGraveSearchChanges();
        this.listenForBaySearchChanges();
        this.listenForPOISearchChanges();
        this.listenForStreetsSearchChanges();
        this.setTableGridSize();
        this.mapSearchObservable = this.applicationMapSearchService.isMapVisible.subscribe((isMapVisible) => {
            if (isMapVisible) {
                this.setTableGridSize();
            }
        });
    }
    setTableGridSize() {
        this.changeDetectorRef.detectChanges();
        const divTableGrid = document.getElementById("divTableGrid");
        if (divTableGrid) {
            if (!this.allowExport)
                divTableGrid.setAttribute("style", this.getClientHeightSetting("100%", 0));
            else {
                this.changeDetectorRef.detectChanges();
                this.isCemeteryModuleSearch = this.moduleConfigService.isCemeteryModule();
                this.setTableGridSizeSubscription = this.searchTableService.containerHeightAsObservable.subscribe((height) => {
                    let extraSearchHeight = 0;
                    if (this.searchCriteriaHeight > 41) {
                        extraSearchHeight = this.searchCriteriaHeight - 41;
                    }
                    if (height === SearchContainerHeight.CemeteryLocationWithoutMap) {
                        divTableGrid.setAttribute("style", this.getClientHeightSetting("77%", 0));
                    }
                    else if (height === SearchContainerHeight.CemeteryLocationMap) {
                        divTableGrid.setAttribute("style", this.getClientHeightSetting("33%", 0));
                    }
                    else if (height === SearchContainerHeight.PropertiesMap) {
                        divTableGrid.setAttribute("style", this.getClientHeightSetting("33%", 0));
                    }
                    else if (height === SearchContainerHeight.CemeterySimple) {
                        divTableGrid.setAttribute("style", this.getClientHeightSetting("100%", 110 + extraSearchHeight));
                    }
                    else if (height === SearchContainerHeight.CemeteryApplicationMap) {
                        divTableGrid.setAttribute("style", this.getClientHeightSetting("30.5%", 0));
                    }
                    else if (height === SearchContainerHeight.Map) {
                        divTableGrid.setAttribute("style", this.getClientHeightSetting("30.5%", 0));
                    }
                    else if (height === SearchContainerHeight.GraveLocationMap) {
                        divTableGrid.setAttribute("style", this.getClientHeightSetting("26.5%", 0));
                    }
                    else {
                        if (extraSearchHeight > 0) {
                            divTableGrid.setAttribute("style", this.getClientHeightSetting("100%", height + 240 + extraSearchHeight));
                        }
                        else {
                            divTableGrid.setAttribute("style", this.getClientHeightSetting("100vh", height + 50));
                        }
                    }
                    this.changeDetectorRef.detectChanges();
                });
            }
        }
    }
    getClientHeightSetting(mainUnit, height) {
        return `height: calc(${mainUnit} - ${height.toString()}px) !important;`;
    }
    radioButtonAction(row) {
        this.selectedRows = [];
        this.selectedRows.push(row);
        this.tableItemsChecked.emit(this.selectedRows);
        this.tableItems.map(tableItem => {
            // @ts-ignore
            if (row.id === tableItem.id) {
                // @ts-ignore
                tableItem.selected = true;
            }
            else {
                // @ts-ignore
                tableItem.selected = false;
            }
        });
    }
    checkBoxAction(row, event) {
        if (!this.disableRowSelect || this.allowSingleSelect || this.checkboxColumn) {
            const index = this.selectedRows.indexOf(row, 0);
            if (this.tableItems && this.allowSingleSelect) {
                this.tableItems.map(tableItem => {
                    // @ts-ignore
                    if (row.id === tableItem.id) {
                        // @ts-ignore
                        tableItem.selected = !row.selected;
                    }
                    else {
                        // @ts-ignore
                        tableItem.selected = false;
                    }
                });
                this.selectedRows = [];
            }
            if (event === false) {
                this.selectedRows.splice(index, 1);
                // set the table item to false
                if (this.tableItems) {
                    this.tableItems.map(tableItem => {
                        // @ts-ignore
                        if (row.id === tableItem.id) {
                            // @ts-ignore
                            tableItem.selected = false;
                        }
                    });
                }
                const checkAllBox = document.getElementById("tableCheckAll_" + this.nextID);
                // @ts-ignore
                if (checkAllBox?.checked) {
                    // @ts-ignore
                    checkAllBox.checked = false;
                }
            }
            else {
                // @ts-ignore
                row.selected = true;
                this.selectedRows.push(row);
            }
            this.tableItemsChecked.emit(this.selectedRows);
        }
    }
    checkedAll(event) {
        if (event === true) {
            this.isSelected = true;
            this.selectedRows = this.tableItems.slice(0);
            for (const selectedRow of this.tableItems) {
                // @ts-ignore
                selectedRow.selected = true;
            }
            this.tableItemsChecked.emit(this.selectedRows);
        }
        else {
            this.isSelected = false;
            this.selectedRows = [];
            for (const selectedRow of this.tableItems) {
                // @ts-ignore
                selectedRow.selected = false;
            }
            this.tableItemsChecked.emit(this.selectedRows);
        }
    }
    executeClickAction(row, column, $event) {
        // @ts-ignore
        this.checkBoxAction(row, !row.selected);
        this.tableItemClicked.emit(row);
    }
    onExportClick() {
        const data = [];
        const headers = [];
        let countRows = 0;
        if (!this.visibleTableItems || this.visibleTableItems.length === 0) {
            this.appControllerService.showMessage(SharedConstants.EXPORT_NO_DATA_MESSAGE, AlertType.Warning);
            return null;
        }
        let hasJobId = false;
        this.tableColumns.forEach((column) => {
            if (column.toString().toLowerCase() === this.jobIdFieldName) {
                hasJobId = true;
            }
        });
        this.visibleTableItems.forEach((item) => {
            const dataRow = {};
            let jobId = null;
            this.tableColumns.forEach((column) => {
                if (countRows === 0) {
                    headers.push(column);
                }
                const value = this.getElementValue(item, column);
                dataRow[`${column}`] = value;
                if (column.toString().toLowerCase() === this.jobIdFieldName) {
                    jobId = value;
                }
            });
            if (hasJobId === true) {
                if (countRows === 0) {
                    headers.push(this.applicationLinkFieldName);
                }
                if (jobId !== null) {
                    let applicationUrl = window.location.origin;
                    if (this.baseHref !== undefined && this.baseHref !== null && this.baseHref !== "") {
                        applicationUrl += this.baseHref;
                    }
                    if (!applicationUrl.endsWith("/")) {
                        applicationUrl += "/";
                    }
                    applicationUrl += +this.appControllerService.selectedModuleID + "/viewapplication/" + jobId + "/content/details";
                    dataRow[`${this.applicationLinkFieldName}`] = { f: `=HYPERLINK("${applicationUrl}")` };
                }
            }
            data.push(dataRow);
            countRows++;
        });
        const fileName = this.exportFilenameText ? this.exportFilenameText : this.exportFilenamePlaceholderText;
        const wb = utils.book_new();
        const ws = utils.json_to_sheet([]);
        utils.sheet_add_aoa(ws, [headers]);
        utils.sheet_add_json(ws, data, { origin: "A2", skipHeader: true });
        utils.book_append_sheet(wb, ws, fileName);
        writeFile(wb, `${fileName}.xlsx`);
    }
    textChanged($event) {
        this.exportFilenameText = $event;
    }
    getElementValue(element, column) {
        const propertyValue = this.getTableItemValue(element, column);
        if (propertyValue === undefined || propertyValue === null) {
            return "";
        }
        if (TableComponent_1.checkIfObject(propertyValue)) {
            throw Error(SharedConstants.INVALID_TABLE_VALUE_ERROR);
        }
        return propertyValue;
    }
    filterTable(filter) {
        this.setQueryParams(filter);
        this.searchTerm = filter.text;
        this.selectedColumn = filter.column;
        if (!filter || !filter.text) {
            this.setInitialVisibleTableItems();
            this.changeDetectorRef.markForCheck();
            return;
        }
        if (filter.column === SharedConstants.FILTER_BY_DEFAULT || filter.column === undefined) {
            this.setVisibleTableItems(this.filterAllTableItems(filter.text));
        }
        else {
            this.setVisibleTableItems(this.filterTableItemsByColumn(filter));
        }
        this.changeDetectorRef.markForCheck();
    }
    onSort({ column, direction }) {
        this.setSortableHeaders(column);
        // @ts-ignore
        if (direction === "" || column === "") {
            this.visibleTableItems = this.tableItems;
        }
        else {
            this.visibleTableItems = this.sortTableItems(this.tableItems, column, direction);
        }
    }
    onRecipientTypeChanged(tableItem, $event) {
        tableItem.emailField = $event.target.value;
        this.recipientRadioButtonClicked.emit(tableItem);
    }
    refreshTableItems(items) {
        if (items) {
            this.tableItems = new Array();
            this.tableItems = items;
            this.isTableItemsRefreshed = true;
            if (this.isTableItemsRefreshed && this.isTableColumnMappingRefreshed)
                this.initialize();
        }
    }
    refreshTableColumnMap(tableColumnMap) {
        if (tableColumnMap) {
            // @ts-ignore
            this.columnToItemPropertyMap = tableColumnMap;
            this.isTableColumnMappingRefreshed = true;
            if (this.isTableItemsRefreshed && this.isTableColumnMappingRefreshed)
                this.initialize();
            else
                this.resetTableColumns();
        }
    }
    getTableDate() {
        return this.tableItems;
    }
    onDefaultSearchCountChanged(target) {
        this.appControllerService.fetchRecordCountValue = target.value;
    }
    resetTableColumns() {
        if (!this.tableItems) {
            this.tableItems = new Array();
        }
        if (this.columnToItemPropertyMap) {
            this.tableColumns = Array.from(this.columnToItemPropertyMap.keys());
            this.initializeFilterOptions();
        }
    }
    initialize() {
        this.resetTableColumns();
        this.visibleTableItems = new Array();
        this.setInitialVisibleTableItems();
        if (!this.defaultSort) {
            this.defaultSort = { column: this.tableColumns[0], direction: "asc" };
        }
        this.isTableColumnMappingRefreshed = false;
        this.isTableItemsRefreshed = false;
    }
    setInitialVisibleTableItems() {
        if (this.tableItems) {
            this.visibleTableItems = this.tableItems.slice(0);
        }
        this.sortByDefault();
        this.changeDetectorRef.markForCheck();
    }
    filterAllTableItems(text) {
        // we only want to search the displayed columns - not all columns in tableItems
        return SearchUtils.searchAllItemsProperties(this.tableItems, text, this.listOfVisibleColumns());
    }
    listOfVisibleColumns() {
        const list = [];
        this.tableColumns.forEach((column) => {
            const mappedColumn = this.columnToItemPropertyMap.get(column);
            // @ts-ignore
            if (mappedColumn)
                list.push(mappedColumn);
        });
        return list;
    }
    filterTableItemsByColumn(search) {
        const mappedColumn = this.columnToItemPropertyMap.get(search.column);
        return SearchUtils.searchAllItemsSingleProperty(this.tableItems, mappedColumn, search.text);
    }
    setVisibleTableItems(items) {
        this.visibleTableItems = items;
    }
    checkForExistingCheckedItems() {
        for (const tableItem of this.visibleTableItems) {
            if (this.selectedRows.includes(tableItem)) {
                if (tableItem.hasOwnProperty("id")) {
                    // @ts-ignore
                    const checkbox = document.getElementById(tableItem.id);
                    checkbox.checked = true;
                }
            }
        }
        this.changeDetectorRef.markForCheck();
    }
    initializeFilterOptions() {
        this.filterByOptions = new Array();
        this.filterByOptions.push(SharedConstants.FILTER_BY_DEFAULT);
        this.filterByOptions.push(..._.values(this.tableColumns));
    }
    setSortableHeaders(column) {
        this.headers.forEach(header => {
            if (header.sortable !== column) {
                header.direction = "";
            }
        });
    }
    getTableItemValue(element, column) {
        return element[this.columnToItemPropertyMap.get(column)];
    }
    sortByDefault() {
        if (this.defaultSort && this.tableItems && this.tableItems.length > 0 && !this.isDataPreSorted) {
            this.visibleTableItems = this.sortTableItems(this.tableItems, this.defaultSort.column, this.defaultSort.direction);
        }
    }
    sortTableItems(tableItems, column, direction = "asc") {
        return [...tableItems].sort((a, b) => {
            // TODO Dylan remove this cast when you remove the link safe html
            const result = compare(this.getCorrectPrimitiveTypeForPropertyValue(this.getElementValue(a, column)), this.getCorrectPrimitiveTypeForPropertyValue(this.getElementValue(b, column)));
            return direction === "asc" ? result : -result;
        });
    }
    getCorrectPrimitiveTypeForPropertyValue(propertyValue) {
        if (!propertyValue) {
            return null;
        }
        if (this.checkIfNumber(propertyValue)) {
            return +propertyValue;
        }
        if (TableComponent_1.checkIfDate(propertyValue)) {
            return propertyValue;
        }
        return propertyValue.toLocaleString()?.toLocaleLowerCase();
    }
    checkIfColumnMappingExists() {
        if (!this.columnToItemPropertyMap) {
            throw new Error(SharedConstants.TABLE_COLUMN_MAPPING_EXISTS_ERROR);
        }
    }
    listenForQueryParamChanges() {
        this.queryParamsSubscription = this.route.queryParams.subscribe((queryParams) => {
            if (this.visibleTableItems !== this.tableItems) {
                this.filterTable({ column: queryParams.column, text: queryParams.text });
                this.preSelectedFilterText = queryParams.text;
                this.preSelectedFilterColumn = queryParams.column;
            }
        });
    }
    setQueryParams(filter) {
        this.router.navigate([], {
            queryParams: {
                text: filter.text,
                column: filter.column
            },
            queryParamsHandling: "merge"
        });
    }
    listenForAppSearchChanges() {
        if (this.parentComponent === "ApplicationsComponent") {
            this.appTableItemsObservableSubscription = this.appTableColumnMappingService.appTableItemsObservable.subscribe((items) => {
                this.refreshTableItems(items);
            });
            this.appTableColumnMapObservableSubscription = this.appTableColumnMappingService.appTableColumnMapObservable.subscribe((tableColumnMap) => {
                this.changeDetectorRef.detectChanges();
                this.refreshTableColumnMap(tableColumnMap);
            });
        }
    }
    listenForPropertySearchChanges() {
        if (this.parentComponent === "PropertiesComponent") {
            this.propertyTableItemsObservableSubscription = this.propertyTableColumnMappingService.propertyTableItemsObservable.subscribe((items) => {
                this.refreshTableItems(items);
            });
            this.propertyTableColumnMapObservableSubscription = this.propertyTableColumnMappingService.propertyTableColumnMapObservable.subscribe((tableColumnMap) => {
                this.changeDetectorRef.detectChanges();
                this.refreshTableColumnMap(tableColumnMap);
            });
        }
    }
    listenForGraveSearchChanges() {
        if (this.parentComponent === "GravesComponent") {
            this.graveTableItemsObservableSubscription = this.propertyTableColumnMappingService.propertyTableItemsObservable.subscribe((items) => {
                this.refreshTableItems(items);
            });
            this.graveTableColumnMapObservableSubscription = this.propertyTableColumnMappingService.propertyTableColumnMapObservable.subscribe((tableColumnMap) => {
                this.changeDetectorRef.detectChanges();
                this.refreshTableColumnMap(tableColumnMap);
            });
        }
    }
    listenForBaySearchChanges() {
        if (this.parentComponent === "BaysComponent") {
            this.bayTableItemsObservableSubscription = this.bayTableColumnMappingService.bayTableItemsObservable.subscribe((items) => {
                this.refreshTableItems(items);
            });
            this.bayTableColumnMapObservableSubscription = this.bayTableColumnMappingService.bayTableColumnMapObservable.subscribe((tableColumnMap) => {
                this.changeDetectorRef.detectChanges();
                this.refreshTableColumnMap(tableColumnMap);
            });
        }
    }
    listenForPOISearchChanges() {
        if (this.parentComponent === "POIsComponent") {
            this.poiTableItemsObservableSubscription = this.POIsTableColumnMappingService.POITableItemsObservable.subscribe((items) => {
                this.refreshTableItems(items);
            });
            this.poiTableColumnMapObservableSubscription = this.POIsTableColumnMappingService.POITableColumnMapObservable.subscribe((tableColumnMap) => {
                this.changeDetectorRef.detectChanges();
                this.refreshTableColumnMap(tableColumnMap);
            });
        }
    }
    listenForStreetsSearchChanges() {
        if (this.parentComponent === "streetsComponent") {
            this.streetTableItemsObservableSubscription = this.streetTableColumnMappingService.streetTableItemsObservable.subscribe((items) => {
                this.refreshTableItems(items);
            });
            this.streetTableColumnMapObservableSubscription = this.streetTableColumnMappingService.streetTableColumnMapObservable.subscribe((tableColumnMap) => {
                this.changeDetectorRef.detectChanges();
                this.refreshTableColumnMap(tableColumnMap);
            });
        }
    }
    expandTableHorizontally() {
        if (this.columnToItemPropertyMap !== undefined && this.columnToItemPropertyMap !== null && this.columnToItemPropertyMap.size > 0 && this.isApplicationSearchTable) {
            this.applyTableWidthClass = true;
        }
        else {
            this.applyTableWidthClass = false;
        }
        this.changeDetectorRef.detectChanges();
    }
    getEmailField(tableItem) {
        return tableItem.emailField || "";
    }
    setDefaultRecipientType() {
        if (this.tableItems && this.tableItems.length > 0)
            this.tableItems.forEach(tableItem => {
                if (!tableItem.emailField) {
                    tableItem.emailField = "To";
                }
            });
    }
    static ctorParameters = () => [
        { type: String, decorators: [{ type: Inject, args: [APP_BASE_HREF,] }] },
        { type: ChangeDetectorRef },
        { type: ActivatedRoute },
        { type: Router },
        { type: ApplicationTableColumnMappingService },
        { type: PropertyTableColumnMappingService },
        { type: BayTableColumnMappingService },
        { type: POITableColumnMappingService },
        { type: StreetTableColumnMappingService },
        { type: ApplicationMapSearchService },
        { type: AppControllerService },
        { type: Renderer2 },
        { type: SearchTableService },
        { type: ModuleConfigService }
    ];
    static propDecorators = {
        headers: [{ type: ViewChildren, args: [TableSortHeaderDirective,] }],
        tableItems: [{ type: Input }],
        columnToItemPropertyMap: [{ type: Input }],
        tdTemplate: [{ type: Input }],
        thTemplate: [{ type: Input }],
        rowActions: [{ type: Input }],
        checkboxColumn: [{ type: Input }],
        showRadioButtonColumn: [{ type: Input }],
        allowSingleSelect: [{ type: Input }],
        disableFilter: [{ type: Input }],
        disableRowSelect: [{ type: Input }],
        nextID: [{ type: Input }],
        pageName: [{ type: Input }],
        defaultSort: [{ type: Input }],
        showRecipientTypeColumn: [{ type: Input }],
        parentComponent: [{ type: Input }],
        allowExport: [{ type: Input }],
        isApplicationSearchTable: [{ type: Input }],
        isDataPreSorted: [{ type: Input }],
        tableItemClicked: [{ type: Output }],
        tableItemsChecked: [{ type: Output }],
        recipientRadioButtonClicked: [{ type: Output }]
    };
};
TableComponent = TableComponent_1 = __decorate([
    Component({
        selector: "app-table[tableItems][columnToItemPropertyMap]",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], TableComponent);
export { TableComponent };
